import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const http = axios.create({ baseURL: API, timeout: 30000 });

export const api = {
  postResult: (payload) => http.post("/results", payload).then((r) => r.data),
  getResult: (id) => http.get(`/results/${id}`).then((r) => r.data),
  checkout: (result_id, origin_url) =>
    http.post("/payments/checkout", { result_id, origin_url }).then((r) => r.data),
  paymentStatus: (session_id) =>
    http.get(`/payments/status/${session_id}`).then((r) => r.data),
  getReport: (result_id, key) =>
    http.get(`/report/${result_id}`, { params: { key } }).then((r) => r.data),
  captureEmail: (email, result_id, source) =>
    http.post("/email/capture", { email, result_id, source }).then((r) => r.data),
  postEvent: (name, props = {}) =>
    http.post("/events", { name, props }).catch(() => {}),
  adminStats: (password) =>
    http.get("/admin/stats", { headers: { "X-Admin-Password": password } }).then((r) => r.data),
  adminBounced: (password) =>
    http.get("/admin/bounced", { headers: { "X-Admin-Password": password } }).then((r) => r.data),
};
